/* template */
<template minapp="mpx" xlang="wxml"><div class="coupon-list-container"><mpx-scroll-view scroll-y :style='[("height:"+(listData.length*89)+"px")] | transRpxStyle' v-if="(listData.length>2)"><div v-for="(item, index) in (listData)" :key="item.index"><coupon-item :couponData="(item)" :couponTheme="(couponTheme)"/></div></mpx-scroll-view><div v-else><div v-for="(item, index) in (listData)" :key="item.index"><coupon-item :couponData="(item)" :couponTheme="(couponTheme)"/></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7da805fa"}'>
  .coupon-list-container
    padding 0 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7da805fa"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./coupon-list.mpx.js?isComponent&outputPath=components%2Fcoupon-list7da805fa%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./coupon-list.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcoupon-list7da805fa%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7da805fa"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/coupon-list7da805fa/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-item':getComponent(require("./coupon-item.mpx?isComponent&outputPath=components%2Fcoupon-item73a28def%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
